import { CelebrityTraining } from '../container';

const Celebrity = () => {
  return <CelebrityTraining />;
};

export default Celebrity;
